import {useOutletContext} from "react-router-dom";
import {EntityViewSubPage} from "base/entity/components/container";
import {ApprovedPermitInspectionGeneralDataSection} from "permit/presentational";
import {EntityCommentsSection} from "base/entity/components/presentational/sections";

const ViewApprovedPermitInspectionSubPage = () => {
    const context = useOutletContext();
    const permit = context[0];

    let sections = [
        <ApprovedPermitInspectionGeneralDataSection
            key="general-data"
            permit={permit}
        />,
        <EntityCommentsSection
            key="comments"
            comments={permit?.comments}
            displayCard
        />,
    ];

    return permit && <EntityViewSubPage sections={sections} />;
};

export default ViewApprovedPermitInspectionSubPage;
